import { z } from 'zod';

/**
 * Validation schemas for the auth forms.
 *
 * Messages are i18n keys (resolved by the form layer through `t()`), not literal
 * strings, so validation stays localizable. The inferred types are the source of
 * truth for the form values.
 */

export const loginSchema = z.object({
  email: z.string().min(1, 'validation.email_required').email('validation.email_invalid'),
  password: z.string().min(1, 'validation.password_required'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({
  email: z.string().min(1, 'validation.email_required').email('validation.email_invalid'),
});

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;

export const registerSchema = z
  .object({
    nume: z.string().trim().min(1, 'validation.last_name_required'),
    prenume: z.string().trim().min(1, 'validation.first_name_required'),
    email: z.string().min(1, 'validation.email_required').email('validation.email_invalid'),
    phone: z.string().trim().min(6, 'validation.phone_invalid'),
    password: z.string().min(8, 'validation.password_min'),
    confirmPassword: z.string().min(1, 'validation.password_confirm_required'),
    terms: z.literal(true, {
      errorMap: () => ({ message: 'validation.terms_required' }),
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'validation.passwords_mismatch',
    path: ['confirmPassword'],
  });

export type RegisterFormValues = z.infer<typeof registerSchema>;

export const verifyOtpSchema = z.object({
  otp: z.string().trim().min(4, 'validation.otp_invalid'),
});

export type VerifyOtpFormValues = z.infer<typeof verifyOtpSchema>;
